import * as React from 'react';
import { IMenuProps } from './menu-props.interface';
import styled from 'styled-components';
import { MenuIcon } from '../../icons';
import { MenuIconContainer } from './atoms';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { DropdownMenu } from './dropdown-menu';
import { HEADER_VIEW_HEIGHT, MENU_ITEM_WIDTH } from './consts';

const MenuWrapper = styled.div`
  display: flex;
  width: 60px;
  flex: 0 0 60px;
`;

@observer
export class HamburgerMenu extends React.Component<IMenuProps> {
  @observable menuContentShown: boolean = false;

  @action
  toggleMenu = () => {
    this.menuContentShown = !this.menuContentShown;
  }

  render() {
    const {logoAlignment, ...props} = this.props;
    const submenuDirection = logoAlignment === 'left' ? -1 : 1;
    return <MenuWrapper>
      <MenuIconContainer
        onClick={this.props.inEditor ? undefined : this.toggleMenu}
        opacity={this.props.backgroundOpacity}
        color={this.menuContentShown ? this.props.hoverTextColor : this.props.textColor}
        hoverColor={this.props.hoverTextColor}
        isSelected={this.menuContentShown}
        backgroundColor={this.props.backgroundColor}
      >
        <MenuIcon />
        {this.menuContentShown && <DropdownMenu {...props} submenuDirection={submenuDirection} left={submenuDirection > 0 ? 0 : (60 - MENU_ITEM_WIDTH)} top={HEADER_VIEW_HEIGHT} onCloseMenu={this.toggleMenu}/>}
      </MenuIconContainer>
    </MenuWrapper>;
  }
}